module.exports = __webpack_public_path__ + "static/media/Harry-Potter.73e299e8.jpg";